
/* =====================================================================
   Las pantallas del carril `asistente` · DIRECTRIZ-ASISTENTE-OPERATIVO
   =====================================================================
   R-AO1 (decisión del dueño, 17 sep 2026): UN solo asistente, «Asistente»,
   en Operación, con todas las herramientas (las 7 con «dato al» y las 18
   de siempre, sus acciones y sus propuestas). La pantalla vieja
   (paginas/Asistente.jsx) queda apagada, no borrada; su ruta
   /api/bot/preguntar sigue viva. El id sigue siendo `asistente` para que
   el botón flotante «Preguntar» y los enlaces de siempre lleguen aquí.
   ===================================================================== */
/* La entrada del menú vive en `ui/modulos.jsx` (id `asistente`, Operación,
   también para cuentas personales): las pruebas de la cuenta personal la
   exigen en la base. Este carril no declara pantallas propias. */
export default {
  orden: 67,
  grupos: [],
};
